module.exports = __webpack_public_path__ + "static/assets/ce63079eb97034bd7d841aab683f7fbd.gif";